import { makeAutoObservable } from 'mobx';
import { AuthStates, IReadableAuthState, IWratableAuthState } from '../../core';

export class AuthStatusStore implements IReadableAuthState, IWratableAuthState {
  constructor() {
    makeAutoObservable(this);
  }

  private state: AuthStates = 'idle';

  get isLoggedIn(): boolean {
    return this.state === 'logged-in';
  }
  get isAuthRequired(): boolean {
    return this.state === 'auth-required';
  }
  get isIdle(): boolean {
    return this.state === 'idle';
  }

  allowAccess(): void {
    this.state = 'logged-in';
  }
  denyAccess(): void {
    this.state = 'auth-required';
  }
}
